export default __webpack_public_path__ + "static/media/logo-1.d7cfa4f7.png";